import vcSportsHubZaEn from './vc-sportshub-za-en'

// Brand configuration mapping
export const brandConfigMap = new Map([
  ['localhost', vcSportsHubZaEn],
  ['localhost:3000', vcSportsHubZaEn],
  ['sportshub.vodacom.co.za', vcSportsHubZaEn]
])

// Get brand config based on domain or URL param
export function getBrandConfig() {
  const urlParams = new URLSearchParams(window.location.search)
  const brandParam = urlParams.get('brand')

  if (brandParam) {
    // If brand is specified in URL params, use that
    return vcSportsHubZaEn
  }

  // Otherwise use domain-based lookup
  const host = window.location.host
  return brandConfigMap.get(host) || vcSportsHubZaEn
}

export default {
  brandConfigMap,
  getBrandConfig
}
